import {
  CREATE_GDOC_ASSET_EDITOR_REFERENCE_REQUEST,
  CREATING_GDOC_ASSET_EDITOR_REFERENCE_SUCCEDDED,
  CREATING_GDOC_ASSET_EDITOR_REFERENCE_FAILED,
  WS_ASSET_EDITOR_CREATED,
  SYNC_GDOC_ASSET_EDITOR_REFERENCE_REQUEST,
  SYNCING_GDOC_ASSET_EDITOR_REFERENCE_SUCCEDDED,
  SYNCING_GDOC_ASSET_EDITOR_REFERENCE_FAILED,
  WS_ASSET_PROCESSED,
} from "../actions/actionTypes";

import { UnknownAction } from "redux-saga";

import _ from "lodash";
import {
  CreatingGDocIntegrationErrorResponse,
  CreatingGDocIntegrationResponse,
  SyncingGDocIntegrationErrorResponse,
  SyncingGDocIntegrationResponse,
} from "src/types/gDocIntegration";

interface GDocIntegrationState {
  creating: boolean;
  syncing: boolean;
  processed: boolean;
  error: any;
  item: any | null;
}

const initialState: GDocIntegrationState = {
  creating: false,
  syncing: false,
  processed: false,
  error: null,
  item: null,
};

type Action = UnknownAction;

export function gDocIntegrationReducer(
  state: GDocIntegrationState = initialState,
  action: Action,
): GDocIntegrationState {
  switch (action.type) {
    case CREATE_GDOC_ASSET_EDITOR_REFERENCE_REQUEST:
      return {
        ...state,
        creating: true,
      };

    case CREATING_GDOC_ASSET_EDITOR_REFERENCE_SUCCEDDED:
      const response = action.payload as CreatingGDocIntegrationResponse;
      return {
        ...state,
        creating: false,
        item: response,
      };

    case CREATING_GDOC_ASSET_EDITOR_REFERENCE_FAILED:
      const { error } = action.payload as CreatingGDocIntegrationErrorResponse;
      return {
        ...state,
        creating: false,
        error: error,
      };

    case WS_ASSET_EDITOR_CREATED:
      var id = action.payload;
      return Object.assign({}, state, {
        ...state,
        creating: false,
        item: action.payload,
        error: null,
      });

    case SYNC_GDOC_ASSET_EDITOR_REFERENCE_REQUEST:
      return {
        ...state,
        syncing: true,
      };
      
    case SYNCING_GDOC_ASSET_EDITOR_REFERENCE_SUCCEDDED:
      const data = action.payload as SyncingGDocIntegrationResponse;
      return {
        ...state,
        syncing: false,
        item: data,
        error: null
      };
     
    case SYNCING_GDOC_ASSET_EDITOR_REFERENCE_FAILED:
      const syncError = action.payload as SyncingGDocIntegrationErrorResponse;
      return {
        ...state,
        syncing: false,
        error: syncError,
      };  

      case WS_ASSET_PROCESSED:
      if(!state.item){
        return state;
      }
      
      var assetId = (action.payload as { id: string }).id;
      var processed = state.item.asset == assetId;
      
      return Object.assign({}, state, {
        ...state,
        processed: processed
      });


    default:
      return state;
  }
}
